import { Grid } from '@hermes/web-components'
import React, { useContext } from 'react'

import SearchField from '../../../SearchField'
import useTranslateMessage from '../../../../hooks/useTranslateMessage'
import { SearchSpecialistsContext } from '../../../../providers/SearchSpecialists'

type SpecialistOverviewProps = {
  countSpecialists: number
}

function SpecialistOverview({ countSpecialists }: SpecialistOverviewProps) {
  const translate = useTranslateMessage()

  const {
    state: { filters },
    changeSort,
    changeSearch
  } = useContext(SearchSpecialistsContext)

  const sortOptions = [
    { name: translate('reviews.newest'), value: 'desc' },
    { name: translate('reviews.oldest'), value: 'asc' },
    { name: translate('sort_by_popularity'), value: 'popular' }
  ]

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SearchField
          changeSort={changeSort}
          changeSearch={changeSearch}
          filters={filters}
          placeholder={translate('search_for_specialist_name')}
          sortOptions={sortOptions}
          titleCount={translate('count_specialists', { count: countSpecialists })}
        />
      </Grid>
    </Grid>
  )
}

export default SpecialistOverview
